import { memo } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import Header from 'UI/sections/Header';
import CookiesNotification from 'UI/components/CookiesNotification';
import { useLayout } from './utils/useLayout';

const Footer = dynamic(() => import('UI/sections/Footer'));
const LoadingScreen = dynamic(() => import('UI/components/LoadingScreen'));
const WhatsAppChat = dynamic(() => import('UI/components/WhatsAppChat'), { ssr: false });
const GAnalytic = dynamic(() => import('components/Layout/GAnalytic'), { ssr: false });

const Layout = (props) => {
  const {
    children,
    introSection,
    isDuckLoading,
    withoutIndexing,
  } = useLayout(props);

  return (
    <>
      {isDuckLoading && <LoadingScreen />}
      {withoutIndexing ? children : (
        <>
          <Header introSection={introSection} />
          {children}
          <WhatsAppChat />
          <Footer />
          <GAnalytic />
          {/* <CookiesNotification /> */}
        </>
      )}
    </>
  );
};

Layout.defaultProps = {
  children: null,
};

Layout.propTypes = {
  children: PropTypes.node,
  introSection: PropTypes.instanceOf(Object).isRequired,
};

export default memo(Layout);
